import axios from '../assets/axios'
import { getKey, setKey, removeKey } from '../assets/utils'

export default {
  namespaced: true,

  state: {
    bankList: [], // 可用银行列表
    bankcardList: [], // 已绑定银行卡列表
    selectedBankcard: {}, // 选择银行卡
    continueSelectBankcard: false // 继续选卡状态
  },

  mutations: {
    setBankList (state, bankList) {
      state.bankList = bankList
    },

    setBankcardList (state, bankcardList) {
      // const res = bankcardList.filter(item => !item.invalid)
      state.bankcardList = bankcardList
    },

    setSelectedBankcard (state, bankcard) {
      state.selectedBankcard = bankcard
    },
    setContinueSelectBankcardStatus (state, status) {
      state.continueSelectBankcard = status
      setKey('continueSelectBankcard', status)
    }
  },

  actions: {
    // 支持银行列表
    async getSupportBankListX ({ commit }, params) {
      const response = await axios.post('/bankCard/v1/supportBanks', params)
      return response.data
    },

    // 已绑卡列表
    async getBankcardListX ({ commit }, params) {
      const response = await axios.post('/bankCard/v1/userBindCardList', params)
      commit('setBankcardList', response.data.data)
      return response.data
    },

    // 绑卡申请
    async bindBankcardApplyX ({ commit }, params) {
      const response = await axios.post('/bankCard/v1/bindApply', params)
      return response.data
    },
    // 绑卡申请v2
    async bindBankcardApplyV2X ({ commit }, params) {
      const response = await axios.post('/bankCard/v2/bindApply', params)
      return response.data
    },

    // 绑卡确认
    async bindBankcardConfirmX ({ commit }, params) {
      const response = await axios.post('/bankCard/v1/bindConfirm', params)
      return response.data
    },
    
    // 绑卡确认v2
    async bindBankcardConfirmV2X ({ commit }, params) {
      const response = await axios.post('/bankCard/v2/bindConfirm', params)
      return response.data
    },

    // 设置默认代扣卡
    async setDefaultBankCardX ({ commit }, params) {
      const response = await axios.post('/bankCard/v1/defaultCard', params)
      return response.data
    },


    getContinueSelectBankcardStatus (state) {
      let localKey = getKey('continueSelectBankcard')
      let status = state.continueSelectBankcard || localKey
      // 获取成功之后就删除掉这个状态的记录
      state.continueSelectBankcard = false
      removeKey('continueSelectBankcard')
      return status
    },


    // 扣款账户
    async overdueBillCardListX ({ commit }, params) {
      const response = await axios.post('/bankCard/v1/overdueBillCardList', params)
      return response.data
    },

    // 扣款账户
    async repayLoanListX ({ commit }, params) {
      const response = await axios.post('/order/v1/repayLoanList', params)
      return response.data
    },

    // 逾期借据无效卡绑卡申请
    async overdueBindApplyX ({ commit }, params) {
      const response = await axios.post('/bankCard/v1/overdueBindApply', params)
      return response.data
    },

    // 逾期借据无效卡绑卡确认
    async overdueBindConfirmX ({ commit }, params) {
      const response = await axios.post('/bankCard/v1/overdueBindConfirm', params)
      return response.data
    },

    // 检查是否需要跳转绑卡页面
    async jumpBindCardPageX ({ commit }) {
      const response = await axios.post('/bankCard/v1/jumpBindCardPage')
      return response.data
    }

  }
}
